import './contentModalTauxLivret.css';

const modalTiBoosteContent = (
  <div className="modal-ti-text">
    <p>Il s&apos;agit du taux promotionnel appliqué pour une première souscription.</p>
    <p>
      Il s&apos;applique sur une période de temps limitée et un plafond d&apos;encours définis dans les conditions
      particulières du contrat de souscription.
    </p>
    <p>Les intérêts sont soumis à des prélèvements fiscaux et sociaux sauf cas d&apos;exonération.</p>
  </div>
);
const modalTiStandardContent = (
  <div className="modal-ti-text">
    <p>
      Il s&apos;agit du taux d&apos;intérêt annuel brut qui s&apos;applique en dehors du taux boosté dont vous avez
      éventuellement bénéficié.
    </p>
    <p>
      Il s&apos;applique donc au-delà de la période de taux boosté et/ou sur les encours supérieurs au plafond défini
      pour bénéficier du taux boosté (les paramètres sont spécifiés dans les conditions particulières de votre contrat).
    </p>
    <div className="modal-ti-sous-text">
      <p>
        Il est susceptible de varier au cours de l&apos;année. La modification du taux peut être effectuée par CFCAL à
        tout moment. Le nouveau taux s&apos;appliquera à compter de la quinzaine suivante.
      </p>
      <p>Les intérêts sont soumis à des prélèvements fiscaux et sociaux sauf cas d&apos;exonération.</p>
    </div>
  </div>
);

export { modalTiBoosteContent, modalTiStandardContent };
